<div class="group-input" [style]="{'width': width}">
  <icons-primecap [name]="icon" [size]="'small'"></icons-primecap>
  <input
    name="statup"
    type="text"
    [placeholder]="placeholder"
    [formControl]="control"
    [value]="itemListaSelecionado"
    (focus)="onFocus()"
    (blur)="onFocus()"
    (keyup)="buscarItem()"
    #inputRef
  >
</div>

<!-- lista de itens na tela de push -->
<div  [ngClass]="isOpended ? 'opended' : 'closeble'" class="dropDown" *ngIf="push" [style]="{'width': width}">
  <div class="listDropDown" *ngFor="let item of listaSelect" (mousedown)="select(item)">
    <div class="item" id="item-1">
      <div class="group-startup-logo">
        <img *ngIf="item.logo" height="30" [src]="item.logo" alt="logo">
        <p class="startup">{{item.principal}}</p>
      </div>
      <p class="tecnologia">{{item.auxiliar}}</p>
    </div>
  </div>
</div>

<!-- lista de itens em outras telas -->
<div  [ngClass]="isOpended ? 'opended' : 'closeble'" class="dropDown" *ngIf="!push" [style]="{'width': width}">
  <div class="listDropDown" *ngFor="let item of listaSelect" (mousedown)="select(item)">
    <div class="item" id="item-1">
      <div class="group-startup-logo">
        <p class="startup">{{item.nome}}</p>
      </div>
    </div>
  </div>
</div>
